"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateLeagueHighlightSearchPatternMappingDto = instanceOfUpdateLeagueHighlightSearchPatternMappingDto;
exports.UpdateLeagueHighlightSearchPatternMappingDtoFromJSON = UpdateLeagueHighlightSearchPatternMappingDtoFromJSON;
exports.UpdateLeagueHighlightSearchPatternMappingDtoFromJSONTyped = UpdateLeagueHighlightSearchPatternMappingDtoFromJSONTyped;
exports.UpdateLeagueHighlightSearchPatternMappingDtoToJSON = UpdateLeagueHighlightSearchPatternMappingDtoToJSON;
exports.UpdateLeagueHighlightSearchPatternMappingDtoToJSONTyped = UpdateLeagueHighlightSearchPatternMappingDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateLeagueHighlightSearchPatternMappingDto interface.
 */
function instanceOfUpdateLeagueHighlightSearchPatternMappingDto(value) {
    return true;
}
function UpdateLeagueHighlightSearchPatternMappingDtoFromJSON(json) {
    return UpdateLeagueHighlightSearchPatternMappingDtoFromJSONTyped(json, false);
}
function UpdateLeagueHighlightSearchPatternMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pattern_id': json['pattern_id'] == null ? undefined : json['pattern_id'],
        'display_order': json['display_order'] == null ? undefined : json['display_order'],
    };
}
function UpdateLeagueHighlightSearchPatternMappingDtoToJSON(json) {
    return UpdateLeagueHighlightSearchPatternMappingDtoToJSONTyped(json, false);
}
function UpdateLeagueHighlightSearchPatternMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'pattern_id': value['pattern_id'],
        'display_order': value['display_order'],
    };
}
